<template>
  <div class="post-order-carousel">
    <v-carousel
      v-model="currentPage"
      hide-delimiters
      :show-arrows-on-hover="true"
      :continuous="false"
    >
      <v-carousel-item
        v-for="(buttonGroup, index) in buttonGroups"
        :key="index"
      >
        <div class="post-order-carousel__navigation-buttons">
          <button
            v-if="showPreviousButton"
            class="post-order-carousel__navigation-button"
            @click="moveButtons('previous')"
          >
            &#10094;
          </button>
          <template>
            <div class="post-order-carousel__order-buttons-container">
              <button
                v-for="(button, buttonIndex) in buttonGroup"
                :key="buttonIndex"
                class="post-order-carousel__order-button"
                size="small"
                @click="orderPosts(button.orderType)"
              >
                {{ button.label }}
              </button>
            </div>
          </template>
          <button
            v-if="showNextButton"
            class="post-order-carousel__navigation-button"
            @click="moveButtons('next')"
          >
            &#10095;
          </button>
        </div>
        <div class="post-order-carousel__line" />
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>

import { POST_ORDER } from '@/store/modules/cards/constants';

export default {
  name: 'PostOrder',
  data() {
    return {
      currentPage: 0,
      buttonsPerPage: 3,
    };
  },
  computed: {
    orderButtons() {
      return [
        { label: this.$t('components.post.PostOrder.label.hot'), orderType: POST_ORDER.HOT },
        { label: this.$t('components.post.PostOrder.label.new'), orderType: POST_ORDER.DESC },
        { label: this.$t('components.post.PostOrder.label.old'), orderType: POST_ORDER.ASC },
        { label: this.$t('components.post.PostOrder.label.influence'), orderType: POST_ORDER.INFLUENCE },
        { label: this.$t('components.post.PostOrder.label.interactions'), orderType: POST_ORDER.INTERACTIONS },
        { label: this.$t('components.post.PostOrder.label.shares'), orderType: POST_ORDER.SHARES },
        { label: this.$t('components.post.PostOrder.label.likes'), orderType: POST_ORDER.LIKES },
        { label: this.$t('components.post.PostOrder.label.comments'), orderType: POST_ORDER.COMMENTS },
      ];
    },
    buttonGroups() {
      const groups = [];
      for (let i = 0; i < this.orderButtons.length; i += this.buttonsPerPage) {
        groups.push(this.orderButtons.slice(i, i + this.buttonsPerPage));
      }
      return groups;
    },
    showPreviousButton() {
      return this.currentPage > 0;
    },
    showNextButton() {
      return this.currentPage < this.buttonGroups.length - 1;
    },
  },
  methods: {
    orderPosts(orderType) {
      this.$emit('order-posts', orderType);
    },
    moveButtons(direction) {
      if (direction === 'next' && this.showNextButton) {
        this.currentPage++;
      } else if (direction === 'previous' && this.showPreviousButton) {
        this.currentPage--;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.post-order-carousel {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__navigation-buttons {
    display: flex;
    align-items: center;
  }

  &__navigation-button {
    margin: 0 4px;
    cursor: pointer;
    font-size: 1.5rem;
  }

  &__order-buttons-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  &__order-button {
    margin: 0 4px;
    padding: 0 4px;
    cursor: pointer;
    transition: background-color 0.3s;
    font-weight: var(--ds-font-weight-semibold);
    font-size: var(--ds-font-size-xs);
    border: var(--ds-border-width-hairline) solid var(--ds-color-overlay);
    border-radius: var(--ds-border-radius-md);

    &:hover {
      background-color: var(--ds-color-overlay);
    }
  }

  &__line {
    width: 100%;
    height: 1px;
    background-color: var(--ds-color-silver);
    margin-top: 8px;
    align-self: center;
  }
}

</style>
